module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-8"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('searchClients', {
    on: {
      "selected": _vm.selectClient
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.visatype),
      expression: "agreement.visatype"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.agreement, "visatype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.visatypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.no_gst),
      expression: "agreement.no_gst"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement.no_gst) ? _vm._i(_vm.agreement.no_gst, null) > -1 : (_vm.agreement.no_gst)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreement.no_gst,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.agreement, "no_gst", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.agreement, "no_gst", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.agreement, "no_gst", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.description),
      expression: "newItem.description"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newItem, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selDesc]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Standard Business Sponsorship"
    }
  }, [_vm._v("Standard Business Sponsorship")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "482 Primary"
    }
  }, [_vm._v("482 Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "482 Nomination"
    }
  }, [_vm._v("482 Nomination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Labour Market Testing (LMT)"
    }
  }, [_vm._v("Labour Market Testing (LMT)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "186 Primary"
    }
  }, [_vm._v("186 Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "186 Nomination"
    }
  }, [_vm._v("186 Nomination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skills Assessment"
    }
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dependant O18"
    }
  }, [_vm._v("Dependant (Family Member over 18)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dependant U18"
    }
  }, [_vm._v("Dependant (Family Member under 18)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Visitor Visa (subclass 600)"
    }
  }, [_vm._v("Visitor Visa (subclass 600)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Onshore Partner Visa Application (sublass 820)"
    }
  }, [_vm._v("Onshore Partner Visa Application (sublass 820)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Offshore Partner Visa Application (sublass 309)"
    }
  }, [_vm._v("Offshore Partner Visa Application (sublass 309)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australian Citizenship Application"
    }
  }, [_vm._v("Australian Citizenship Application")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "189 Application"
    }
  }, [_vm._v("189 Application")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "190 Application"
    }
  }, [_vm._v("190 Application")]), _vm._v(" "), (_vm.otheritem) ? _c('option', {
    domProps: {
      "value": _vm.otheritem
    }
  }, [_vm._v(_vm._s(_vm.otheritem))]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newItem.cost),
      expression: "newItem.cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newItem.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newItem.quantity),
      expression: "newItem.quantity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "value": "1"
    },
    domProps: {
      "value": (_vm.newItem.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])])]), _vm._v(" "), _vm._l((_vm.agreement.items), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.delItem(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])])
  }), _vm._v(" "), (_vm.total) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.total)))]), _vm._v(" "), _c('td')]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.withInvoice) ? _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.withInvoice = false
      }
    }
  }, [_vm._v("Remove Invoice")])]) : (_vm.newAgreement) ? _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement created")]), _vm._v(" "), (_vm.newAgreement && _vm.newAgreement.sent) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement sent")]) : _vm._e()]) : _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.withInvoice = true
      }
    }
  }, [_vm._v("Add Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (_vm.agreementErr) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.agreementErr))]) : _vm._e()]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.withInvoice),
      expression: "withInvoice"
    }],
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvItem.description),
      expression: "newInvItem.description"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newInvItem, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selItem]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.descriptions), function(d) {
    return _c('option', {
      domProps: {
        "value": d
      }
    }, [_vm._v(_vm._s(d))])
  })], 2)]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newInvItem.cost),
      expression: "newInvItem.cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.newInvItem.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newInvItem, "cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addInvItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])])]), _vm._v(" "), _vm._l((_vm.invoice.items), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(item.cost)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.delInvItem(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])])
  }), _vm._v(" "), (_vm.totals[0]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("GST")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[0])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[1]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Surcharge")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[1])))])]) : _vm._e(), _vm._v(" "), (_vm.totals[2]) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm.c2d(_vm.totals[2])))])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9 flexcol"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan),
      expression: "plan"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan) ? _vm._i(_vm.plan, null) > -1 : (_vm.plan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plan = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-5 col-ml-auto"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Initial payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_initial),
      expression: "plan_initial",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_initial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_initial = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Monthly payment $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plan_monthly),
      expression: "plan_monthly",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.plan_monthly)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan_monthly = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), (_vm.newAgreement) ? _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), (_vm.newAgreement.sent) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement and invoice sent")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agreement and invoice created")])]) : _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (_vm.invoiceErr) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.invoiceErr))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.othermodal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Item description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otheritem),
      expression: "otheritem"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.otheritem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otheritem = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.othermodal = false;
        _vm.newItem.description = _vm.otheritem
      }
    }
  }, [_vm._v("Done")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.otherInvModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Item description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvDesc),
      expression: "newInvDesc"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.newInvDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newInvDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInvItem.surcharge),
      expression: "newInvItem.surcharge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newInvItem.surcharge) ? _vm._i(_vm.newInvItem.surcharge, null) > -1 : (_vm.newInvItem.surcharge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newInvItem.surcharge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newInvItem, "surcharge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newInvItem, "surcharge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newInvItem, "surcharge", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Surcharge\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addInvDesc($event)
      }
    }
  }, [_vm._v("Done")])])])]), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "agreement": _vm.newAgreement,
      "invoice": _vm.newInvoice
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Service Category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("No GST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Payment plan")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7dca5e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreements/makeAgreement.vue
// module id = 518
// module chunks = 1